import React, { CSSProperties } from 'react';

import Icon, { IconSize } from 'common/components/Icon';
import { Image } from 'common/components/image';
import variables from 'common/config/variables';
import { TestableComponent } from 'common/interfaces';

interface Props extends TestableComponent {
  id: string;
  icon?: {
    activeState?: boolean;
    activeIcon?: string;
    inactiveIcon?: string;
    size?: IconSize;
    style?: CSSProperties;
  };
  position: number;
  channelLogo: string;
  name: string;
}

function InnerSettingsToggleChannel({ id, icon, position, channelLogo, name, testId }: Props) {
  const renderIcon = () => {
    const component = icon?.activeState ? icon?.activeIcon : icon?.inactiveIcon;
    return typeof component === 'string' ? (
      <Icon src={component} size={icon?.size || 'medium'} style={icon?.style} />
    ) : (
      component
    );
  };
  return (
    <div
      className="inner-settings-toggle-item"
      key={id}
      data-test-id={testId}
      data-checked={!!icon?.activeState}
    >
      {/* action icon */}
      <div className="action-icon">
        {icon?.activeIcon && icon?.inactiveIcon && renderIcon()}
        {!icon?.activeIcon || !icon?.inactiveIcon}
      </div>
      {/* channel position */}
      <div className="channel-position">{position}</div>
      {/* channel logo */}
      <div className="channel-logo">
        <Image src={channelLogo} fallbackSrc={variables.DEFAULT_LEFT_LOGO_PATH} />
      </div>
      {/* channel name */}
      <div className="channel-name">{name}</div>
    </div>
  );
}

export default React.memo(InnerSettingsToggleChannel);
